module.exports = __webpack_public_path__ + "img/quickFunImg03.23e3c097.png";